// -*- mode: vue; js-indent-level: 2; -*-
<template lang="html">
  <b-overlay :show="is_loading" rounded="sm">
  <div class="product" v-if="!is_loading && hasBeer">
    <beer-header :title="displayName"></beer-header>

    <b-row class="badge-header" align-h="center">
      <b-col class="background" sm="8">
        <img class="label" :src="beer.imageUri|product_image_url" :alt="displayName">
      </b-col>
    </b-row>

    <b-row class="about" align-h="center">

      <b-col :sm="hasSpecifications ? 4 : 8" class="left">
        <div class="text" :class="{ 'centered-content': !hasSpecifications }">
          <h2  class="beer-subtitle">Qu'est ce que ?</h2>
          <p class="description" v-html="normalizedDescription"></p>
        </div>
      </b-col>
      <b-col v-if="hasSpecifications" class="right" sm="4">
        <div class="text">
          <div class="caract-section">
            <h2 class="beer-subtitle">Caractéristiques</h2>

            <b-row v-if="beer.type && beer.type.libelle">
              <b-col class="caract-title" cols="4">
                Style
              </b-col>
              <b-col class="caract-value" cols="8">
                {{ beer.type.libelle }}
              </b-col>
            </b-row>

            <b-row v-if="beer.degreAlcool">
              <b-col class="caract-title" cols="4">
                Alcool
              </b-col>
              <b-col class="caract-value" cols="8">
                {{ beer.degreAlcool }}%
              </b-col>
            </b-row>
          </div>

          <div class="caract-section" v-if="beer.amertume">
            <h2 class="beer-subtitle">Amertume</h2>

            <IBUGauge :ibus="beer.amertume"/>

          </div>
        </div>
      </b-col>
    </b-row>

    <monkey-footer/>

  </div>
  </b-overlay>
</template>

<script lang="js">
import { mapState } from 'vuex'

import BeerHeader from './Header.vue'
import IBUGauge from './Ibu.vue'
import MonkeyFooter from '../Footer.vue'

export default {
  name: 'ProductDetail',

  computed: {
    ...mapState({
      beer: 'current_beer_details'
    }),
    hasBeer: function () {
      return !!(this.beer && this.beer.slug)
    },
    displayName: function () {
      return this.beer.nomCommercial || this.beer.nom
    },
    normalizedDescription: function () {
      var description = this.beer.description || ''
      return description
        .replace(/\u00a0/g, ' ')
        .replace(/&nbsp;/gi, ' ')
    },
    hasSpecifications: function () {
      return !!(
        (this.beer.type && this.beer.type.libelle) ||
        this.beer.degreAlcool ||
        this.beer.amertume
      )
    }
  },

  components: {
    BeerHeader,
    MonkeyFooter,
    IBUGauge
  },

  data: function () {
    return {
      is_loading: true
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  beforeUpdate: function () {
    window.scrollTo(0, 0)
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function () {
      var slug = this.$route.params.slug
      this.is_loading = true
      this.$store.commit('SET_BEER_DETAILS', { details: {} })
      this.$store.dispatch('LOAD_BEER_DETAILS', { slug: slug })
        .catch(() => {})
        .then(() => {
          this.is_loading = false
        })
    }
  },
  filters: {
    product_image_url (uri) {
      if (!uri) {
        return ''
      }
      if (uri.startsWith('http://') || uri.startsWith('https://')) {
        return uri
      }
      return 'https://erp.singe-savant.com/' + uri
    }
  }

}
</script>

<style lang="scss" scoped>
.buy {
    height: 50vh;



    .col-8 {
        background-image: url(/images/product/bg-shop.jpg);
        background-size: cover;

        text-align: center;

        font-size: 4vh;
        color: white;
        text-transform: uppercase;

        padding-top: 10vh;

        button, a {
            margin-top: 5vh;
        }

        a {
            color: #d06f5a;
        }

        .smaller {
            margin-top: 1em;
            font-size: 1rem;
        }

    }
}

h2.beer-subtitle {
    width: 100%;
    text-align: center;
    font-size: 1.2em;
    font-variant: small-caps;

    background: url(/images/product/h2-icon.png), url(/images/product/h2-icon.png);
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: 0%, 100%;

    margin-bottom: 20px;
}


.product {
    height: 100%;
    width: 100%;
    background-color: #eee;

    .badge-header {
        text-align: center;
        background-color: rgba(0, 0, 0, 0);
        position: relative;
        margin-top: -10vh;
        height: 40vh;

        img {
            height: 50vh;
            background-color: white;
            border-radius: 50%;
            position: absolute;
            top: -15vh;
            margin-left: -25vh;
        }

        .background {
            background-color: white;
        }
    }


    .about {
        justify-content: center;

        .left, .right {
            background-color: white;

            line-height: 200%;

            .text {
                padding: 40px;
                width: 100%;
            }

            .text.centered-content {
                max-width: 50%;
                margin: 0 auto;
                
                @media (max-width: 767.98px) {
                    max-width: 100%;
                    width: 100%;
                }
            }


            .caract-section {
                margin-bottom: 30px;

                .row {
                    margin-bottom: 10px;

                }
            }

            .caract-value {
                font-weight: 300;
            }

            .description {
                text-align: justify;
                font-weight: 300;
                white-space: normal;
                overflow-wrap: anywhere;
                word-break: break-word;
                max-width: 100%;
            }

        }
    }

    .more {
        background-color: white;
        justify-content: center;

        .left {
          padding: 40px;
        }
    }
}
</style>
